import client from './client';

export const packagesApi = {
  async list() {
    const { data } = await client.get('/api/packages');
    return data;
  },

  async get(packageName) {
    const { data } = await client.get(`/api/packages/${encodeURIComponent(packageName)}`);
    return data;
  },

  async refresh(packageName) {
    const { data } = await client.post(`/api/packages/${encodeURIComponent(packageName)}/refresh`);
    return data;
  },

  async refreshAll() {
    const { data } = await client.post('/api/packages/refresh-all');
    return data;
  },

  async createUpgradePR(packageName, projectKey, targetVersion) {
    const { data } = await client.post(`/api/packages/${encodeURIComponent(packageName)}/upgrade-pr`, {
      projectKey,
      targetVersion,
    });
    return data;
  },

  async getUpgradePRStatus(jobId) {
    const { data } = await client.get(`/api/packages/-/jobs/${jobId}`);
    return data;
  },
};
